import { TransactionsView } from "../views/TransactionsView.tsx";
import { DomainLayout } from "@/components/layouts/DomainLayout";

export const TransactionsPage = () => {
  return (
    <DomainLayout>
      <TransactionsView />
    </DomainLayout>
  );
};
